/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Include_FormattingInputs */

const en_include_formatting = /** @type {(inputs: Include_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Formatting`)
};

const fr_include_formatting = /** @type {(inputs: Include_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclure la mise en forme`)
};

const de_include_formatting = /** @type {(inputs: Include_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatierung einschließen`)
};

const it_include_formatting = /** @type {(inputs: Include_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includi formattazione`)
};

const ru_include_formatting = /** @type {(inputs: Include_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить форматирование`)
};

const es_include_formatting = /** @type {(inputs: Include_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir formato`)
};

const zh_cn2_include_formatting = /** @type {(inputs: Include_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含格式`)
};

const ja_include_formatting = /** @type {(inputs: Include_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書式設定を含める`)
};

const hi_include_formatting = /** @type {(inputs: Include_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉर्मेटिंग शामिल करें`)
};

const pt_pt2_include_formatting = /** @type {(inputs: Include_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir formatação`)
};

/**
* | output |
* | --- |
* | "Include Formatting" |
*
* @param {Include_FormattingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const include_formatting = /** @type {((inputs?: Include_FormattingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Include_FormattingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_include_formatting(inputs)
	if (locale === "de") return de_include_formatting(inputs)
	if (locale === "it") return it_include_formatting(inputs)
	if (locale === "ru") return ru_include_formatting(inputs)
	if (locale === "es") return es_include_formatting(inputs)
	if (locale === "zh-CN") return zh_cn2_include_formatting(inputs)
	if (locale === "ja") return ja_include_formatting(inputs)
	if (locale === "hi") return hi_include_formatting(inputs)
	if (locale === "pt-PT") return pt_pt2_include_formatting(inputs)
	return en_include_formatting(inputs)
});